"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.start = exports.isAProtectedBranch = exports.needBlockPullRequest = void 0;
const github_1 = require("@actions/github");
const core_1 = require("@actions/core");
exports.needBlockPullRequest = (allowedBranch) => (originBranchName) => allowedBranch.toLowerCase() !== originBranchName.toLowerCase();
const blockPullRequest = (pullRequestProperties) => __awaiter(void 0, void 0, void 0, function* () {
    const octokit = github_1.getOctokit(core_1.getInput('github-token'));
    yield octokit.issues.createComment({
        repo: github_1.context.repo.repo,
        owner: github_1.context.repo.owner,
        body: core_1.getInput('close-message') || '⛔ Invalid branch',
        issue_number: pullRequestProperties.number
    });
    return yield octokit.pulls.update({
        repo: github_1.context.repo.repo,
        owner: github_1.context.repo.owner,
        pull_number: pullRequestProperties.number,
        state: 'closed'
    });
});
exports.isAProtectedBranch = (protectedBranchParameter) => (baseBranchName) => protectedBranchParameter.toLowerCase() === baseBranchName.toLowerCase();
exports.start = () => __awaiter(void 0, void 0, void 0, function* () {
    const pullRequestProperties = github_1.context.payload.pull_request;
    if (!pullRequestProperties) {
        core_1.warning('This action only works in a pull_request event');
        return;
    }
    const baseBranchName = pullRequestProperties.base.ref;
    if (!exports.isAProtectedBranch(core_1.getInput('protected-branch'))(baseBranchName)) {
        return;
    }
    const originBranchName = pullRequestProperties.head.ref;
    if (exports.needBlockPullRequest(core_1.getInput('allowed-branch'))(originBranchName)) {
        yield blockPullRequest(pullRequestProperties);
    }
    console.log(2, originBranchName);
});
